import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { InvoiceStatusEnum } from "../../data/enums";

export namespace ResellerInvoiceValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Entries = defineValidation(
        defineRecordSchema({
            filters: v.object({
                status: v.optional(v.picklist(InvoiceStatusEnum.values)),
                minDate: v.optional(baseVals.isoDate()),
                maxDate: v.optional(baseVals.isoDate()),
            }),
        }),
    );

    export const Create = defineValidation(
        v.object({
            resellerId: baseVals.string(),
            amount: baseVals.intRange(10_000, 1_000_000, "Saldo"),
        }),
    );

    export namespace API {
        export const Create = defineValidation(
            v.object({
                amount: baseVals.intRange(50_000, 1_000_000, "Saldo"),
            }),
        );
    }
}
